import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable, MDBBadge } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';

import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';


import LoadingOverlay from 'react-loading-overlay';
import Modalshowcitizen from './Modalshowcitizen';







import {ExcelFile, ExcelSheet} from "react-data-export";



export default class RoomReport extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',

                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                roomreport:[],
                room2:[],
                room3:[],
                loading:false,
                date1:'',
                date2:'',
                summoney:[],
                manny:'0',
                moneylist:[],

            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getwork = this.getwork.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttomanufacture = this.senttomanufacture.bind(this);
            this.sentpdf = this.sentpdf.bind(this);
            this.getroom = this.getroom.bind(this);
            this.handleChange2 = this.handleChange2.bind(this);
            this.handleChange3 = this.handleChange3.bind(this);
            this.getreport = this.getreport.bind(this);
            this.getreportlist = this.getreportlist.bind(this);
            this.getroomsearch = this.getroomsearch.bind(this);
            
          }

          getreport (){
           
            api.get('lkselectreportmoney.php?date1='+this.state.date1+'&date2='+this.state.date2)
            .then(res => {
            //  console.log(res);
            this.setState({ summoney: res.data,
                 manny: res.data[0].manny,
                // numberroom: res.data[0].numberroom,
                loading: false })
            }) 
            this.getreportlist()

          }

          getreportlist (){
            api.get('lkselectreportmoneylist.php?date1='+this.state.date1+'&date2='+this.state.date2)
            .then(res => {
            //  console.log(res);
            this.setState({ moneylist: res.data,
                // numberroom: res.data[0].numberroom,
                loading: false })
            }) 
          }


          

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

         handleChange2(event) {    this.setState({date1: event.target.value});  }
         handleChange3(event) {    this.setState({date2: event.target.value});  }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getwork (){
          this.setState({ loading:true})
        
            api.get('selectworkslforgraphic.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ work: res.data, loading: false })
            }) 
        }

        getroom (){
            this.setState({ loading:true})
          
              api.get('selectreportstatus.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ roomreport: res.data, loading: false })
              }) 

              api.get('selectroomstatus2.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room2: res.data, loading: false })
              }) 

              api.get('selectroomstatus3.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room3: res.data, loading: false })
              }) 
          }

          getroomsearch (){
            this.setState({ loading:true})
        
      
              api.get('selectreportstatussearck.php?date1='+this.state.date1+'&date2='+this.state.date2)
              .then(res => {
              //  console.log(res);
              this.setState({ roomreport: res.data,
                  loading: false })
              }) 

           
              

          }


        

        sentpdf(event) {
          const id = event.target.value;
          setTimeout(() => {
            window.open('https://lookmaenamping.com/sorlalumbackend/TCPDF-main/slfrom.php?id_workorder='+id+'', '_blank');
             // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
           }, 0);
        }
       

        senttomanufacture(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายผลิต",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttomanufacture.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายผลิตสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/kprurun2021'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = 'https://lookmaenamping.com/sorlalum'
            } else {
  
            }
              this.getroom();
          }
        

    render() {
      console.log(this.state.date1)
      console.log(this.state.date2)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;

//            const date = year + '-' + month + '-' + day;
     //console.log(date)
     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
          {
            label: 'เวลาเข้า',
            field: 'start',
            sort: 'start',
            width: 100
          },
          {
            label: 'เวลาออก',
            field: 'end',
            sort: 'end',
            width: 100
          },
          {
            label: 'เบอร์ผู้เข้าพัก',
            field: 'tel',
            sort: 'tel',
            width: 100
          },
          
          {
            label: 'ภาพ',
            field: 'pic',
            sort: 'pic',
            width: 100
          }
          

        ],

        rows: [...this.state.roomreport.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroomck} <br/>{data.status === '9'?<> <MDBBadge color="success">ย้ายไปห้อง {data.roommove}</MDBBadge> : {data.comment}</>:<></>}</>,
             price: <>{data.price}</>,
             start: <>{data.timestart}</>,
             end: <>{data.timeend}</>,
             tel: <>{data.tel}</>,
             pic: <> 
             {data.pic_idcard === '' || data.pic_idcard === null ?<>ไม่มีภาพ</>:<>
               <Modalshowcitizen id_time={data.id_time} id_room={data.id_room} timestart={data.timestart} timeend={data.timeend} numberroomck={data.numberroomck} />
             </>}
           
              </>
            //  pic: <>  <Modalshowcitizen id_room={data.id_room}/> </>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const data2 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room2.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>เข้าพัก</>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const data3 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room3.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>ทำความสะอาด</>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={10}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>

const persons2 = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data2}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>

const persons3 = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data3}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>

const dataSet1 = [...this.state.work.map((data, i) => (

  {
      name: data.numberroom,
      amount: 30000,
      sex: 'M',
      is_married: true
  }
))
];

const dataSet2 = [
  {
      name: "Johnson",
      total: 25,
      remainig: 16
  },
  {
      name: "Josef",
      total: 25,
      remainig: 7
  }
];
      

        return (
       
          <LoadingOverlay
  active={this.state.loading}
  spinner
  text='Loading your data...'
  >
                <MDBContainer fluid >
                
  <h2 className="font-weight-bold  text-center">  รายงานผู้เข้าพัก</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้งาน</p>
      <MDBRow >
          {/* <div >
              <Modaladdwork/> 
          </div> */}
       
        <MDBCol md="12" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    <MDBCardTitle className="text-center">  ข้อมูลเข้าพัก</MDBCardTitle>
                    <MDBRow>
       
           
      </MDBRow>
               <div className="text-center">
               <MDBRow className='text-center'>
               <MDBCol sm="2">
               </MDBCol>
                    <MDBCol sm="4">
                        <MDBInput type="date" label="วันที่เข้า" value={this.state.date1} onChange={this.handleChange2} outline />
                    </MDBCol>
                    <MDBCol sm="4">
                        <MDBInput type="date" label="วันที่ออก" value={this.state.date2} onChange={this.handleChange3} outline />
                    </MDBCol>
                    <MDBCol sm="2">
                    </MDBCol>

                </MDBRow>
                 <MDBBtn color="primary" onClick={this.getroomsearch}>ค้นหา</MDBBtn>
                </div>
                {/* <ExcelFile>
                <ExcelSheet dataSet={data} name="Organization"/>
            </ExcelFile> */}
            

                      {persons}
                    <br/>

                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     
                    </MDBCardBody>
                   
   
         </MDBCard>
        </MDBCol>


      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>

  


                   
                    </MDBContainer>
                   </LoadingOverlay>  
     
        )
    }
}
